(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["barepace-bogo-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bp-bogo-picker')) {
  customElements.define('bp-bogo-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.inventory = JSON.parse(this.querySelector('[data-inventory]').textContent);
      this.variantMedia = JSON.parse(this.querySelector('[data-variant-media]').textContent);
      this.stock = this.querySelector('[data-stock]');
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.addEventListener('change', (event) => {
        this.update();
        const pair = event.target.closest('[data-pair]');
        if (pair) this.syncMedia(pair);
      });
      this.button.addEventListener('click', () => this.addPairs());
      this.update();
    }
    selected() {
      return Array.from(this.querySelectorAll('[data-pair]')).map(pair => {
        const values = Array.from(pair.querySelectorAll('select')).map(select => select.value);
        return this.variants.find(variant => variant.options.every((value, index) => value === values[index]));
      });
    }
    async syncMedia(pair) {
      const values = Array.from(pair.querySelectorAll('select')).map(select => select.value);
      const exact = this.variantMedia.find(item => item.options.every((value, index) => value === values[index]));
      const media = exact?.src ? exact : this.variantMedia.find(item => item.src && item.options[0] === values[0]);
      if (!media?.src) return;
      const section = this.closest('.shopify-section');
      const gallery = section?.querySelector('media-gallery');
      const slideshow = gallery?.querySelector('slideshow-component');
      if (!slideshow) return;
      const request = this.mediaRequest = (this.mediaRequest || 0) + 1;
      await customElements.whenDefined('slideshow-component');
      if (request !== this.mediaRequest || !this.isConnected) return;
      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      const index = slides.findIndex(slide => slide.querySelector('[data-media-id="' + media.mediaId + '"]'));
      if (index >= 0 && typeof slideshow.select === 'function') {
        slideshow.select(index, undefined, { animate: false });
      }
    }
    update() {
      const selected = this.selected();
      const valid = selected.every(variant => variant && variant.available);
      this.stock.textContent = selected.map((variant, index) => {
        const stock = variant && this.inventory.find(item => item.id === variant.id);
        if (!stock || stock.managed !== 'shopify' || stock.quantity <= 0 || !variant.available) return '';
        return '#' + (index + 1) + ': ' + stock.quantity + ' pairs left in stock';
      }).filter(Boolean).join(' · ');
      this.button.disabled = this.busy || !valid;
      this.status.textContent = valid ? '' : this.dataset.unavailable;
    }
    async addPairs() {
      if (this.busy) return;
      const variants = this.selected();
      if (!variants.every(variant => variant && variant.available)) return;
      this.busy = true;
      this.update();
      this.querySelector('[data-ready]').hidden = true;
      this.querySelector('[data-busy]').hidden = false;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: variants.map(variant => ({id: variant.id, quantity: 1}))})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.textContent = error.message || this.dataset.error;
        this.busy = false;
        this.button.disabled = false;
        this.querySelector('[data-ready]').hidden = false;
        this.querySelector('[data-busy]').hidden = true;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["barepace-snug-bogo-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bp-bogo-picker')) {
  customElements.define('bp-bogo-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.inventory = JSON.parse(this.querySelector('[data-inventory]').textContent);
      this.variantMedia = JSON.parse(this.querySelector('[data-variant-media]').textContent);
      this.stock = this.querySelector('[data-stock]');
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.addEventListener('change', (event) => {
        this.update();
        const pair = event.target.closest('[data-pair]');
        if (pair) this.syncMedia(pair);
      });
      this.button.addEventListener('click', () => this.addPairs());
      this.update();
    }
    selected() {
      return Array.from(this.querySelectorAll('[data-pair]')).map(pair => {
        const values = Array.from(pair.querySelectorAll('select')).map(select => select.value);
        return this.variants.find(variant => variant.options.every((value, index) => value === values[index]));
      });
    }
    async syncMedia(pair) {
      const values = Array.from(pair.querySelectorAll('select')).map(select => select.value);
      const exact = this.variantMedia.find(item => item.options.every((value, index) => value === values[index]));
      const media = exact?.src ? exact : this.variantMedia.find(item => item.src && item.options[0] === values[0]);
      if (!media?.src) return;
      const section = this.closest('.shopify-section');
      const gallery = section?.querySelector('media-gallery');
      const slideshow = gallery?.querySelector('slideshow-component');
      if (!slideshow) return;
      const request = this.mediaRequest = (this.mediaRequest || 0) + 1;
      await customElements.whenDefined('slideshow-component');
      if (request !== this.mediaRequest || !this.isConnected) return;
      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      const index = slides.findIndex(slide => slide.querySelector('[data-media-id="' + media.mediaId + '"]'));
      if (index >= 0 && typeof slideshow.select === 'function') {
        slideshow.select(index, undefined, { animate: false });
      }
    }
    update() {
      const selected = this.selected();
      const valid = selected.every(variant => variant && variant.available);
      this.stock.textContent = selected.map((variant, index) => {
        const stock = variant && this.inventory.find(item => item.id === variant.id);
        if (!stock || stock.managed !== 'shopify' || stock.quantity <= 0 || !variant.available) return '';
        return '#' + (index + 1) + ': ' + stock.quantity + ' pairs left in stock';
      }).filter(Boolean).join(' · ');
      this.button.disabled = this.busy || !valid;
      this.status.textContent = valid ? '' : this.dataset.unavailable;
    }
    async addPairs() {
      if (this.busy) return;
      const variants = this.selected();
      if (!variants.every(variant => variant && variant.available)) return;
      this.busy = true;
      this.update();
      this.querySelector('[data-ready]').hidden = true;
      this.querySelector('[data-busy]').hidden = false;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: variants.map(variant => ({id: variant.id, quantity: 1}))})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.textContent = error.message || this.dataset.error;
        this.busy = false;
        this.button.disabled = false;
        this.querySelector('[data-ready]').hidden = false;
        this.querySelector('[data-busy]').hidden = true;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
